exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fuse-quick-panel {\n  display: -ms-flexbox;\n  display: flex;\n  width: 330px;\n  min-width: 330px;\n  max-width: 330px;\n  z-index: 99;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  fuse-quick-panel .mat-slide-toggle-content {\n    -ms-flex: 1;\n        flex: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/quick-panel/quick-panel.component.scss
// module id = ../../../../../src/app/main/quick-panel/quick-panel.component.scss
// module chunks = main